import { render, staticRenderFns } from "./JianKang_DataCenterList.vue?vue&type=template&id=25cff88c&scoped=true"
import script from "./JianKang_DataCenterList.vue?vue&type=script&lang=js"
export * from "./JianKang_DataCenterList.vue?vue&type=script&lang=js"
import style0 from "./JianKang_DataCenterList.vue?vue&type=style&index=0&id=25cff88c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25cff88c",
  null
  
)

export default component.exports